module.exports = __webpack_public_path__ + "static/media/amazon.6c2684b8.svg";